module.exports = __webpack_public_path__ + "static/media/z2.16177358.JPG";